import classNames from 'classnames';
import { Column } from '@carbon/react';
import { DefinitionList } from 'components/definition-list';
import { DefinitionDescription } from 'components/definition-list/definition-description';
import { DefinitionTerm } from 'components/definition-list/definition-term';
import { DocumentResponse } from 'types/api-responses';
import { getDocumentFields } from './utils';

import style from './document-attributes.module.scss';

const DocumentAttributes = ({
  document,
  singleColumn,
}: {
  document: DocumentResponse;
  singleColumn?: boolean;
}) => {
  const fields = getDocumentFields(document);
  const midpoint = Math.ceil(fields.length / 2);
  const firstColumn = fields.slice(0, midpoint);
  const secondColumn = fields.slice(midpoint);

  return (
    <div
      className={classNames({
        [style.documentSingleColumn]: singleColumn,
        [style.documentTwoColumns]: !singleColumn,
      })}
    >
      <Column className={style.documentList}>
        {firstColumn.map(({ label, render }) => (
          <DefinitionList key={label}>
            <DefinitionTerm>{label}</DefinitionTerm>
            <DefinitionDescription>
              <span>{render(document)}</span>
            </DefinitionDescription>
          </DefinitionList>
        ))}
      </Column>
      <Column className={style.documentList}>
        {secondColumn.map(({ label, render }) => (
          <DefinitionList key={label}>
            <DefinitionTerm noBorder>{label}</DefinitionTerm>
            <DefinitionDescription>
              <span>{render(document)}</span>
            </DefinitionDescription>
          </DefinitionList>
        ))}
      </Column>
    </div>
  );
};

export { DocumentAttributes };
